import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from 'styled-components/macro';
import SpeechStream from 'components/SpeechStream';
import UserInfoConfirmationModal from 'components/UserInfoConfirmationModal';
import { ErrorProvider } from 'contexts/ErrorContext';
import GlobalStyle from './GlobalStyle';
import useRouter from './routes/Routes';
import theme from './theme';
import { loadSpeechStreamToolbar } from 'services/SpeechStreamService/speechstream';
import PhoneNumberFormModal from './components/PhoneNumberFormModal';

function App() {
  const router = useRouter();
  useEffect(() => {
    loadSpeechStreamToolbar().then();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle theme={null} />
      <Helmet defaultTitle='Home' titleTemplate='Infinitec - %s' />
      <ErrorProvider>
        <RouterProvider router={router} />
        <SpeechStream />
      </ErrorProvider>
      <UserInfoConfirmationModal />
      <BrowserRouter>
        <PhoneNumberFormModal />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
